import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRentalmanagement = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Layer_1",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	x: "0px",
	y: "0px",
	width: "24px",
	height: "24px",
	viewBox: "0 0 24 24",
	style: { enableBackground: "new 0 0 24 24" },
	xmlSpace: "preserve",
	...props,
	children: [/* @__PURE__ */ _jsx("path", { d: "M4.5,9.5h15v10h-15V9.5z M16.5,7.5V6h3v2.5h-15V6h3v1.5h1V6h7v1.5H16.5z M15.5,3.5V5h-7V3.5h-1V5h-4v15.5h17V5h-4V3.5H15.5z " }), /* @__PURE__ */ _jsx("path", { d: "M15,11.6c-0.3-0.3-0.7-0.5-1.1-0.6c-0.4-0.1-0.8,0-1.2,0.3c-0.4,0.2-0.6,0.6-0.8,1c-0.1,0.4-0.1,0.8,0,1.2l-3.4,3.3V18h1.2 v-0.9h0.9v-0.7h0.8v-0.6h0.7v-0.8h0.5l0.4-0.4c0.4,0.2,0.8,0.2,1.2,0.1c0.4-0.1,0.8-0.4,1-0.7c0.2-0.3,0.3-0.8,0.3-1.2 C15.5,12.3,15.3,11.9,15,11.6z M14.5,12.8c-0.1,0.1-0.2,0.2-0.4,0.2c-0.1,0-0.2,0-0.3-0.1c-0.1-0.1-0.2-0.1-0.2-0.2 c0-0.1-0.1-0.2,0-0.3c0-0.1,0.1-0.2,0.1-0.3c0.1-0.1,0.2-0.1,0.3-0.1c0.1,0,0.2,0,0.3,0c0.1,0,0.2,0.1,0.2,0.2 c0.1,0.1,0.1,0.2,0.1,0.3C14.6,12.5,14.6,12.7,14.5,12.8z" })]
});
export default SvgRentalmanagement;
